import { AppBar, Box, Stack, Toolbar, Typography } from "@mui/material";
import React from "react";
// Import logo from the same directory
import logoNav from "../assets/img/logo.png";

const NavigationSection = () => {
  return (
    <AppBar
      position="static"
      color="transparent"
      elevation={0}
      sx={{
        height: "70px",
        px: { xs: 2, md: 12.5 }, // 100px equivalent
        backgroundColor: "black"
      }}
    >
      <Toolbar
        disableGutters
        sx={{ height: "100%", justifyContent: "space-between" }}
      >
        {/* Logo and Brand Name */}
        <Stack direction="row" alignItems="center" spacing={1}>
          {/* Logo image */}
          <Box
            component="img"
            src={logoNav}
            alt="Alfa Team Logo"
            sx={{ 
              width: 40, 
              height: 40, 
              objectFit: "contain",
              mr: 1 
            }}
          />
          <Typography
            variant="h5"
            sx={{
              fontFamily: "'Outfit-Bold', Helvetica",
              fontWeight: 700,
              color: "white",
              fontSize: "1.5rem", // 24px
              lineHeight: "1.5rem", // 24px
              whiteSpace: "nowrap",
            }}
          >
            AlfaTeam
          </Typography>
        </Stack>
      </Toolbar>
    </AppBar>
  );
};

export default NavigationSection;